import React from "react";
import LastNameInput from "../../../../../../components/inputs/lastName/lastNameInput";
import { CoachListContext } from "../../../context/coachListContext";
import CoachProps from "../../../interface/coachProps";
import EditCoachProps from "../../../interface/editCoachProps";

const RenderLastNameInput = (): React.JSX.Element => {
  const {
    setEditCoach,
    editCoach,
  }: {
    setEditCoach: (editCoach: {
      showDialog: boolean;
      coach: CoachProps;
    }) => void;
    editCoach: EditCoachProps;
  } = React.useContext(CoachListContext);
  return (
    <LastNameInput
      disabled={false}
      required={true}
      lastName={editCoach.coach.nachname}
      setLastName={(lastName: string) =>
        setEditCoach({
          ...editCoach,
          coach: {
            ...editCoach.coach,
            nachname: lastName,
          },
        })
      }
    />
  );
};

export default RenderLastNameInput;
